import React from 'react';
import { isMobile } from 'react-device-detect';
import MobileDashboard from './MobileDashboard';
import Dashboard from './dashboard/dashboard';
import Pricing from './Pricing/pricing';
import MobilePricing from './Pricing/MobilePricing';

const PricingWrapper = () => {
  return isMobile ? <MobilePricing /> : <Pricing />;
};

export default PricingWrapper; 